module.exports = __webpack_public_path__ + "static/img/wepay.485786b.png";


//////////////////
// WEBPACK FOOTER
// ./src/comm/assets/wepay.png
// module id = Q/yf
// module chunks = 9